import { Ref } from 'react';

import { ResponseStatus } from '@revenuemarket/http';
import { Toast } from '@revenuemarket/ui';
import { InputRef } from 'antd';
import { useEditCompanySpecificCategories } from '~hooks/queries/categories/query';
import { useDemoAwareCompanyId } from '~hooks/useDemoAwareCompanyId';
import { MIXPANEL_EVENT } from '~libs/mixpanel/event';
import { mixpanel } from '~pages/_app';

import NameInput from './common/component/NameInput';

interface InputProps {
  categoryId: number;
  id: number;
  name: string;
  description?: string;
  parentId: number | null;
  inputRef?: Ref<InputRef>;
}

export const CATEGORY_NAME_MAX_LENGTH_INFO = '20자 까지만 입력할 수 있어요.';
export const CATEGORY_NAME_MAX_LENGTH = 20;

const CategoryNameInput: React.FC<InputProps> = ({
  name,
  categoryId,
  id,
  description,
  parentId,
  inputRef,
}) => {
  const { companyId } = useDemoAwareCompanyId();

  const { mutateAsync: editCategories, isLoading } = useEditCompanySpecificCategories();

  const onSave = async (nameInput: string) => {
    const response = await editCategories({
      companyId,
      categoryId,
      id,
      request: {
        name: nameInput,
        description,
        parentId: parentId ?? undefined,
      },
    });

    if (response.Status === ResponseStatus.SUCCESS) {
      Toast.success('계정 이름이 변경되었습니다.');
      mixpanel.track(MIXPANEL_EVENT.CATEGORY.CHANGE_CATEGORY_NAME);
      mixpanel.track(MIXPANEL_EVENT.ENGAGEMENT.DEFAULT, {
        type: 'CHANGE_CATEGORY_NAME',
      });
    } else {
      Toast.error('계정 이름 변경에 실패했습니다.');
    }
  };

  return <NameInput inputRef={inputRef} name={name} isLoading={isLoading} onSave={onSave} />;
};

export default CategoryNameInput;
